import { render, staticRenderFns } from "./legend-footer.vue?vue&type=template&id=1fe54bd0&scoped=true"
import script from "./legend-footer.vue?vue&type=script&lang=js"
export * from "./legend-footer.vue?vue&type=script&lang=js"
import style0 from "./legend-footer.vue?vue&type=style&index=0&id=1fe54bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe54bd0",
  null
  
)

export default component.exports